// {
//     eventId : "e1687186312078",
//     event_name : 'Zumba',
//     eDescription : 'Zumba',
//     start_date: "2023-06-19T20:24",
//     end_date: "2023-06-20T20:24",
//     event_frequency : 1,
//     compul : false
// }
import { deleteEventGroup } from "./Group";
import { generateUUID } from "../../components/helpers/uuidgenerator";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Trash2 } from "lucide-react";

export const Event = ({ formStates, setFormStates, i, j, eventItem }) => {
  const handleChange = (i, j, name, value) => {
    setFormStates((prev) => {
      let cArr = [...prev.challenge];
      let eArr = cArr[i].event;
      eArr[j] = { ...eArr[j], [name]: value };
      return { ...prev, challenge: [...cArr] };
    });
  };

  const deleteEvent = (i, j) => {
    if (eventItem.group_id) {
      deleteEventGroup(
        i,
        eventItem.group_id,
        setFormStates,
        eventItem.event_id
      );
    }

    setFormStates((prev) => {
      let cArr = [...prev.challenge];
      let eArr = [...cArr[i].event];
      let deletedObj = {
        ...prev.deleted,
        event: [...prev.deleted.event, eArr[j]],
      };
      eArr.splice(j, 1);
      cArr[i] = { ...cArr[i], event: [...eArr] };
      let newObj = { ...prev, challenge: [...cArr], deleted: deletedObj };
      return newObj;
    });
  };

  // Format date for datetime-local input
  const formatDateTimeLocal = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <div id={j} className="space-y-4">
      <div className="flex justify-between items-center">
        <h5 className="text-lg font-semibold">Event no. {j + 1}</h5>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => deleteEvent(i, j)}
        >
          <Trash2 className="h-4 w-4 text-red-600" />
        </Button>
      </div>

      <div>
        <Label htmlFor={`event_name_${i}_${j}`}>Event Name</Label>
        <Input
          type="text"
          name="event_name"
          id={`event_name_${i}_${j}`}
          onChange={(e) => handleChange(i, j, e.target.name, e.target.value)}
          value={eventItem.event_name}
          placeholder="e.g., Yoga session, Family Trek"
        />
        <p className="text-sm text-gray-500 mt-1">
          Example: Yoga session, Family Trek, etc.
        </p>
      </div>

      <div>
        <Label htmlFor={`event_description_${i}_${j}`}>Event Description</Label>
        <Textarea
          name="event_description"
          id={`event_description_${i}_${j}`}
          rows={4}
          onChange={(e) => handleChange(i, j, "event_description", e.target.value)}
          value={eventItem.event_description}
          placeholder="Describe the event..."
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor={`start_date_${i}_${j}`}>Start Date & Time</Label>
          <Input
            type="datetime-local"
            name="start_date"
            id={`start_date_${i}_${j}`}
            value={formatDateTimeLocal(eventItem.start_date)}
            onChange={(e) =>
              handleChange(i, j, "start_date", new Date(e.target.value))
            }
          />
        </div>
        <div>
          <Label htmlFor={`end_date_${i}_${j}`}>End Date & Time</Label>
          <Input
            type="datetime-local"
            name="end_date"
            id={`end_date_${i}_${j}`}
            value={formatDateTimeLocal(eventItem.end_date)}
            onChange={(e) =>
              handleChange(i, j, "end_date", new Date(e.target.value))
            }
          />
        </div>
      </div>

      <div>
        <Label htmlFor={`event_frequency_${i}_${j}`}>
          Event Frequency (number of times event is to be completed in the tenure)
        </Label>
        <Input
          type="number"
          name="event_frequency"
          id={`event_frequency_${i}_${j}`}
          min="0"
          value={eventItem.event_frequency}
          onChange={(e) => handleChange(i, j, e.target.name, e.target.value)}
        />
      </div>
    </div>
  );
};

export const eventObj = (eventId, group_id) => {
  return {
    event_id: eventId,
    event_name: "",
    event_description: "",
    start_date: "",
    end_date: "",
    group_id: group_id,
    event_frequency: 0,
  };
};

export const addEvent = (i, setFormStates, group_id, defaultData) => {
  let eventId = "e" + String(generateUUID());
  setFormStates((prev) => {
    let chArr = [...prev.challenge];
    chArr[i] = {
      ...chArr[i],
      event: [
        ...chArr[i].event,
        { ...eventObj(eventId, group_id), ...defaultData },
      ],
    };
    let newObj = { ...prev, challenge: [...chArr] };

    return newObj;
  });
  return eventId;
};

export default Event;
